import React from "react";
import PropTypes from "prop-types";
import Popover from "../../Popover";
import BaseSection, { AvatarLink, Item } from "../components/BaseSection";

/**
 * SideNavTeamsSection - Renders the "My Teams" section of the side navigation
 *
 * Handles presentation and layout. Business logic (team types, badges) should be handled
 * via custom renderTeamsSection prop in SideNavV2.
 *
 * @param {Array} teams - Array of teams with avatar, name, link, gradient
 * @param {boolean} isExpanded - Whether the sidebar is expanded
 */
const SideNavTeamsSection = ({ teams, isExpanded }) => {
  const renderTeamItem = (team, isExpanded) => {
    const { avatar, name, link, gradient } = team;

    // Skip rendering if required props are missing
    if (!name || !link) {
      return null;
    }

    return (
      <Item key={name}>
        {isExpanded ? (
          <AvatarLink
            avatar={avatar}
            name={name}
            link={link}
            shape="square"
            showName={true}
            gradient={gradient}
          />
        ) : (
          <Popover text={name} direction="right" width="fit-content">
            <AvatarLink
              avatar={avatar}
              name={name}
              link={link}
              shape="square"
              showName={false}
              gradient={gradient}
            />
          </Popover>
        )}
      </Item>
    );
  };

  return (
    <BaseSection
      title="My Teams"
      items={teams || []}
      isExpanded={isExpanded}
      renderItem={renderTeamItem}
    />
  );
};

SideNavTeamsSection.propTypes = {
  teams: PropTypes.arrayOf(
    PropTypes.shape({
      avatar: PropTypes.string,
      name: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      gradient: PropTypes.string
    })
  ),
  isExpanded: PropTypes.bool
};

export default SideNavTeamsSection;
